import { ListItem, ListItemIcon, ListItemText, Avatar } from "@mui/material";
import { BiUser } from "react-icons/bi";

interface ActorDemandadoListInterface {
  nombre: string;
}

export const ActorDemandadoList = ({ nombre }: ActorDemandadoListInterface) => {
  return (
    <ListItem>
      <ListItemIcon>
        <Avatar sx={{ color: "#ffffff" }}>
          <BiUser />
        </Avatar>
      </ListItemIcon>
      <ListItemText>{nombre}</ListItemText>
    </ListItem>
  );
};
